import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const fineChargesList = createAsyncThunk("fineCharges/list", async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `fine_management`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
                unit_id: data?.unit_id,
                charge_type_id: data?.charge_type_id,
                created_at: data?.date && moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const fineChargesDetails = createAsyncThunk("fineCharges/details", async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `fine_management/${id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addFineCharges = createAsyncThunk("fineCharges/add", async (data) => {
    try {
        const res = await axios({
            method: "POST",
            url: getConfig.API_URL + "fine_management",
            data: {
                premise_id: data?.values?.premise_id,
                zone_id: data?.values?.zone_id ?? "",
                level_id: data?.values?.level_id ?? "",
                unit_id: data?.values?.unit_id ?? "",
                charge_type_id: data?.values?.charge_type_id,
                charge_amount: data?.values?.amount,
                description: data?.values?.description ?? "",
                add_invoice: data?.values?.add_invoice,
                add_tax: data?.values?.tax_applicable,
                status: "Active",
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateFineCharges = createAsyncThunk("fineCharges/update", async (data) => {
    try {
        const res = await axios({
            method: "PUT",
            url: getConfig.API_URL + "fine_management",
            data: {
                fine_management_id: data?.values?.id,
                premise_id: data?.values?.premise_id,
                zone_id: data?.values?.zone_id ?? "",
                level_id: data?.values?.level_id ?? "",
                unit_id: data?.values?.unit_id ?? "",
                charge_type_id: data?.values?.charge_type_id,
                charge_amount: data?.values?.amount,
                description: data?.values?.description ?? "",
                add_invoice: data?.values?.add_invoice,
                add_tax: data?.values?.tax_applicable,
                status: "Active",
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const deleteFineCharges = createAsyncThunk("fineCharges/delete", async (data) => {
    try {
        const res = await axios({
            method: "DELETE",
            url: getConfig.API_URL + `fine_management/${data?.id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const fineCharges = createSlice({
    name: "fineCharges",
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(fineChargesList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })

        builder.addCase(fineChargesDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    },
})

export default fineCharges.reducer;